import {ActivatedRouteSnapshot, CanActivate, CanLoad, Route} from '@angular/router';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable()
export class DevGuard implements CanActivate, CanLoad {
  canActivate(route: ActivatedRouteSnapshot): boolean {
    return !environment.production;
  }

  canLoad(route: Route): boolean {
    return !environment.production;
  }
}



// WEBPACK FOOTER //
// ./src/app/state/guard/dev-guard.ts